import { AfterViewInit, ChangeDetectionStrategy, Input, ChangeDetectorRef, Component, EventEmitter, inject, Output, ViewChild } from '@angular/core';
import { MatTableDataSource, MatTableModule } from '@angular/material/table';
import { MatInputModule } from '@angular/material/input';
import { MatFormFieldControl, MatFormFieldModule } from '@angular/material/form-field';
import { MatButtonModule } from '@angular/material/button';
import { CommonModule, NgFor, NgIf } from '@angular/common';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatOptionModule, provideNativeDateAdapter } from '@angular/material/core';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { MatPaginator, MatPaginatorIntl, MatPaginatorModule } from '@angular/material/paginator';
import { MatIconModule } from '@angular/material/icon';
import { MatDialog, MatDialogModule } from '@angular/material/dialog';
import { DialogConfermaComponent } from '../dialog-conferma/dialog-conferma.component';
import { SicotService } from '../sicot.service';
import { MatCardModule } from '@angular/material/card';
import { MatListModule } from '@angular/material/list';
import { MatTabsModule } from '@angular/material/tabs';
import { GestioneRichiestaComponent } from '../cruscotto-richiesta/dettaglio-richiesta/gestione-richiesta/gestione-richiesta.component';
import { StepperDettaglioComponent } from '../cruscotto-richiesta/dettaglio-richiesta/stepper-dettaglio/stepper-dettaglio.component';
import { FooterComponent } from '../footer/footer.component';
import { HeaderComponent } from '../header/header.component';
import { EsitoUvmComponent } from '../richiesta-utils/esito-uvm/esito-uvm.component';
import { Qualifica, SessioneUvmComponent } from '../richiesta-utils/sessione-uvm/sessione-uvm.component';
import { ActivatedRoute, Router } from '@angular/router';
import { QualificheComponent } from '../qualifiche/qualifiche.component';
import { OperatoriComponent } from '../operatori/operatori.component';
import { StruttureComponent } from "../strutture/strutture.component";
import { FormBuilder, FormGroup, FormsModule, ReactiveFormsModule, Validators } from '@angular/forms';
import { MatMenuModule } from '@angular/material/menu';
import { MatSelectModule } from '@angular/material/select';
import { MatSortModule } from '@angular/material/sort';
import { AttivitaComponent } from "../attivita/attivita.component";
import { InterventoPaziente } from '../types/InterventoPaziente';
import { MatStepper, MatStepperModule } from '@angular/material/stepper';
import { Operatore } from '../types/Operatore';
import { Struttura } from '../types/Struttura';
import { Attivita } from '../types/CotEsitoUvm';
import { Footer } from '../types/Footer';
import { FrequenzaComponent } from '../frequenza/frequenza.component';
import { TipoIntervento } from '../types/TipoIntervento';

@Component({
  selector: 'app-scelta-pde',
  standalone: true,
  imports: [MatStepperModule, MatTableModule,
    MatPaginatorModule,
    MatMenuModule,
    MatSortModule,
    MatIconModule,
    MatButtonModule,
    ReactiveFormsModule, FormsModule,
    MatCardModule,
    FrequenzaComponent,
    MatFormFieldModule, MatInputModule, MatOptionModule, MatSelectModule, MatDatepickerModule, OperatoriComponent, QualificheComponent, MatFormFieldModule, MatTabsModule, MatCardModule, MatButtonModule, MatDialogModule, MatListModule, MatIconModule, NgFor, NgIf, MatTableModule, MatPaginatorModule, CommonModule, MatProgressBarModule, StruttureComponent, AttivitaComponent],
  templateUrl: './scelta-pde.component.html',
  styleUrl: './scelta-pde.component.css'
})
export class SceltaPdeComponent implements AfterViewInit {
  isChecked = true;



  isLinear = false;

  @Input() idRichiesta: any;

  @Output() valueChanged = new EventEmitter<any>();

  
  @Output() qualificaByIntervento = new EventEmitter<any>();
  qualificaByInterventoValue: any;

  @Output() attivitaByIntervento = new EventEmitter<any[]>();
  attivitaByInterventoValue: any[] = [];

  @ViewChild('stepper') stepper!: MatStepper;

  @ViewChild(MatPaginator) paginator: MatPaginator = new MatPaginator(new MatPaginatorIntl(), ChangeDetectorRef.prototype);

  //displayedColumns: string[] = ['cognome','nome','qualifica', 'action'];
  dataSource: any;
  operatori: any;
  esito: any;
  saveIntervento: InterventoPaziente[] | undefined;
  dataSoruceSelected: any;
  filtroDisponibilita: boolean = true;
  sceltaDisponibilita: boolean = false;
  qualifiche: Qualifica[] = [];
  selectedQualifiche: any[] = [];
  selectedOperatore: any[] = [];
  selectedStrutture: any[] = [];
  selectedAttivita: any[] = [];
  frequenzaInserita: any;
  idIntervento: any;
  avanti: number = 0

  tipoIntervento: TipoIntervento | undefined;


  interventoPazienteData: any[] = [];

  interventoView: any
  qualificheView: Qualifica[] = []
  operatoreViewNome: Operatore[] = []
  operatoreViewCognome: Operatore[] = []
  struttureView: Struttura[] = []
  attivitaView: Attivita[] = []


  formRicerca = this.fb.group({
    frequenza: ['']
  });

  page = {
    elements: 0,    // richieste totali
    size: 10,       // richieste per pagina
    index: 0        // pagina corrente
  }

  displayedColumns: string[] = [
    'apri',
    'tipoIntervento',
    'codTipoErogatore',
    
    'tipoFrequenza',
    'numeroAccessiPrevisti',
    'attivita'
    
  ];


  displayedColumnsInterventoPaziente: string[] = [
    'tipoIntervento',
    'tipoOperatore',
    'operatore',
    'strutturaRiferimento',
    'frequenza',
    'attivita'
  ];

  displayedColumns2: string[] = ['descrizione', 'action'];
  interventoControl: FormGroup;
  qualificheControl: FormGroup;
  operatoreControl: FormGroup;
  strutturaControl: FormGroup;
  frequenzaControl: FormGroup;
  attivitaControl: FormGroup;
  esitoUvmIniziale: MatTableDataSource<any>;
  interventoIniziale: MatTableDataSource<any>;

  constructor(private siCotService: SicotService, private activatedRoute: ActivatedRoute, private router: Router, private fb: FormBuilder, private formBuilder: FormBuilder) {
    this.interventoControl = this.formBuilder.group({
      primo: [null, Validators.required],
    });
    this.qualificheControl = this.formBuilder.group({
      secondo: [null, Validators.required],
    });
    this.operatoreControl = this.formBuilder.group({
      terzo: [null, Validators.required],
    });
    this.strutturaControl = this.formBuilder.group({
      quarto: [null, Validators.required],
    });
    this.frequenzaControl = this.formBuilder.group({
      frequenza: [null, Validators.required],
    });
    this.attivitaControl = this.formBuilder.group({
      sesto: [null, Validators.required],
    });

    this.esitoUvmIniziale = new MatTableDataSource<any>();

    this.interventoIniziale = new MatTableDataSource<any>();
  }

  ngOnInit(): void {
    let id = this.activatedRoute.snapshot.paramMap.get('id');
    if (id) {
      this.idRichiesta = parseInt(id);
    } else {
      return;
    }

    this.esitoUVM();
    this.getInterventoPaziente();

  }

  esitoUVM() {
    this.siCotService.getEsitoUvm(this.idRichiesta)
      .subscribe({
        next: (response: any) => {
          this.esitoUvmIniziale = new MatTableDataSource<any>(response.interventi);
          this.esito = response;
          
        },
        error: (error: any) => {
          console.error('Errore durante l\'esecuzione delle operazioni:', error);
          const interventi = [{
              id:0
          }]
          this.esitoUvmIniziale = new MatTableDataSource<any>(interventi);
          this.esito = {
            setting : {
              "id": 1,
              "descrizione": "ASSISTENZA DOMICILIARE (ereditato da setting proposto)",
              "codice": "1"
            }
          }
        }
      });
  }

  applyFilter(event: Event) {
    const filterValue = (event.target as HTMLInputElement).value;
    this.dataSource.filter = filterValue.trim().toLowerCase();
    this.dataSource.paginator = this.paginator;
  }

  ngAfterViewInit() {
    this.dataSource.paginator = this.paginator;
  }




  apriRichiesta(intervento: any) {
    
    let id = intervento.id;
    this.interventoView = intervento;
    this.idIntervento = id;
    this.interventoControl.get('primo')?.setValue(this.idIntervento)
    this.qualificaByIntervento.emit(intervento?.codTipoErogatore)
    this.qualificaByInterventoValue = intervento?.codTipoErogatore;
    this.attivitaByIntervento.emit(intervento?.attivita)
    this.attivitaByInterventoValue = intervento?.attivita;
    console.log("EVENTO PKSAOKOA", JSON.stringify(this.attivitaByInterventoValue));
    console.log(this.attivitaByInterventoValue)
    this.stepper.next();
    this.incrementaStepper()

  }

  gestisciQualifiche(qualificheId: any[]) {
    this.selectedQualifiche = qualificheId
    this.qualificheView = this.selectedQualifiche[0].descrizione
    console.log("qualifiche"+this.selectedQualifiche[0].id)
    this.qualificheControl.get('secondo')?.setValue(this.selectedQualifiche)
    this.stepper.next();
    this.incrementaStepper()
  }

  gestisciOperatori(operatoreId: any[]) {
    this.selectedOperatore = operatoreId;
    this.operatoreViewNome = this.selectedOperatore[0].nome
    this.operatoreViewCognome = this.selectedOperatore[0].cognome
    this.operatoreControl.get('terzo')?.setValue(this.selectedOperatore);
    this.stepper.next();
    this.incrementaStepper()
  }

  gestisciStrutture(struttureId: any[]) {
    this.selectedStrutture = struttureId;
    this.struttureView = this.selectedStrutture[0].denominazione
    this.strutturaControl.get('quarto')?.setValue(this.selectedStrutture);
    this.stepper.next();
    this.incrementaStepper()
  }

  /*gestisciFrequenza() {
    this.frequenzaInserita = this.formRicerca.get('frequenza')?.value;
    this.frequenzaControl.get('frequenza')?.setValue(this.frequenzaInserita);
    this.stepper.next();
    this.incrementaStepper()
  }*/

    gestisciFrequenza(frequenzaId: any) {
      this.frequenzaInserita = frequenzaId;
      this.frequenzaControl.get('frequenza')?.setValue(this.frequenzaInserita);
      this.stepper.next();
      this.incrementaStepper()
    }

  gestisciAttvita(attivitaId: any[]) {
    this.selectedAttivita = attivitaId;
    this.attivitaControl.get('sesto')?.setValue(this.selectedAttivita);
    this.stepper.next();
    this.ultimoStepper()
  }




  ultimoStepper() {
    let salvainterventoPaziente = new InterventoPaziente()
    salvainterventoPaziente.tipoInterventoId = this.esito.setting?.id;
    salvainterventoPaziente.richiestaId = this.idRichiesta;
    salvainterventoPaziente.tipoOperatore = this.selectedQualifiche[0].id;
    salvainterventoPaziente.operatoreId = this.selectedOperatore[0].id;
    salvainterventoPaziente.strutturaId = this.selectedStrutture[0].id;
    salvainterventoPaziente.frequenza = this.frequenzaInserita;
    salvainterventoPaziente.attivita = this.selectedAttivita;
    this.siCotService.salvainterventoPaziente(salvainterventoPaziente)
      .subscribe({
        next: (response: any) => {
          this.saveIntervento = response;
          this.getInterventoPaziente();
          this.valueChanged.emit(true);
        },
        error: (error: any) => {
          console.error('Errore durante l\'esecuzione delle operazioni:', error);
        }
      });
    this.avanti = 0;
    this.stepper.reset();

  }

  incrementaStepper() {
    this.avanti += 1;
  }


  getInterventoPaziente() {
    this.siCotService.getInterventiPazienteByRichiesta(this.idRichiesta)
      .subscribe({
        next: (response: any[]) => {
          this.interventoIniziale = new MatTableDataSource<any>(response);
          this.interventoPazienteData = response;
          console.log('PROVAAAA completate con successo:', response);
        },
        error: (error: any) => {
          console.error('Errore durante l\'esecuzione delle operazioni:', error);
        }
      });
  }

}
